import { Helmet } from 'react-helmet-async';
import Header from '../shared/Header/Header';
import { SOCIALS } from '../../constants/common';
import Feedback from '../shared/Footer/feedback/Feedback';
import MapEmbed from './mapEmbed/MapEmbed';
import BackButton from '../shared/backButton/BackButton';
import Footer from '../shared/Footer/Footer';
import useIsLTE650 from '../../hooks/useIsLTE650';
import ActionLinkButton from '../UI/ActionLinkButton/ActionLinkButton';
import './contactsPage.scss';

const ContactsPage: React.FC = () => {
    const isMobile = useIsLTE650(650);

    // универсальный JSON-LD (Organization)
    const orgSchema = {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        '@id': 'https://s-gabai.ru/#org',
        name: 'S-Gabai',
        legalName: 'ООО «ИНТРЕЙД»',
        url: 'https://s-gabai.ru/',
        logo: 'https://s-gabai.ru/logo/sgabai_logo_1024.jpg',
        description: 'Интернет-магазин шелковых изделий S-Gabai: подушки, одеяла, аксессуары из натурального шёлка.',
        email: 'mailto:sales@s-gabai.ru',
        telephone: '+7-495-280-60-55',
        contactPoint: [
            {
                '@type': 'ContactPoint',
                telephone: '+7-495-280-60-55',
                contactType: 'customer service',
                areaServed: 'RU',
                availableLanguage: ['ru'],
            },
        ],
        address: {
            '@type': 'PostalAddress',
            streetAddress: 'ул. Промышленная, стр. 1, корп. 4, оф. 114',
            addressLocality: 'г. о. Химки, с. Чашниково',
            postalCode: '141580',
            addressRegion: 'Московская область',
            addressCountry: 'RU',
        },
        openingHoursSpecification: [
            {
                '@type': 'OpeningHoursSpecification',
                dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
                opens: '10:00',
                closes: '18:00',
            },
        ],
        hasMap: 'https://yandex.ru/maps/-/CHdaa8Ms',
    };

    // расширенный JSON-LD для Яндекса с реквизитами
    const yaSchema = {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        '@id': 'https://s-gabai.ru/#org-ya',
        name: 'S-Gabai',
        legalName: 'ООО «ИНТРЕЙД»',
        taxID: '5044123930',
        vatID: '504701001',
        identifier: 'ОГРН 1215000130619',
        url: 'https://s-gabai.ru/',
        telephone: '+7-495-280-60-55',
        email: 'mailto:sales@s-gabai.ru',
        address: {
            '@type': 'PostalAddress',
            streetAddress: 'ул. Промышленная, стр. 1, корп. 4, оф. 114',
            addressLocality: 'г. о. Химки, с. Чашниково',
            postalCode: '141580',
            addressRegion: 'Московская область',
            addressCountry: 'RU',
        },
        openingHours: 'Mo-Fr 10:00-18:00',
        sameAs: ['https://yandex.ru/maps/-/CHdaa8Ms'],
    };

    return (
        <div className="contactsPage">
            <Helmet>
                <title>Контакты интернет-магазина S-Gabai</title>
                <meta
                    name="description"
                    content="Свяжитесь с нами: тел.: +7-495-280-60-55, e-mail: sales@s-gabai.ru, адрес: 141580, МО, г. о. Химки, с. Чашниково, ул. Промышленная, стр. 1, корп. 4, оф. 114. Консультации по подбору шелковых подушек и одеял. Тел.: +7 495 280-60-55"
                />
                <link rel="canonical" href="https://s-gabai.ru/contacts/" />
                <script type="application/ld+json">{JSON.stringify(orgSchema)}</script>
                <script type="application/ld+json">{JSON.stringify(yaSchema)}</script>
            </Helmet>
            <Header isMobile={isMobile} />
            <main className="contactsPage__main">
                <div className="contactsPage__main_titleBox">
                    <BackButton />
                    <h1 className="contactsPage__main_title">Контакты</h1>
                </div>
                <div className="contactsPage__main_contactsBox">
                    <div className="contactsPage__main_contactsBox_wrapper">
                        {SOCIALS.vk && (
                            <a
                                className="contactsPage__main_contactsBox_button"
                                href={SOCIALS.vk}
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="Мы во ВКонтакте"
                            >
                                ВКонтакте
                            </a>
                        )}
                        {SOCIALS.ig && (
                            <a
                                className="contactsPage__main_contactsBox_button"
                                href={SOCIALS.ig}
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="Мы в Instagram"
                            >
                                Instagram
                            </a>
                        )}
                        {/* {SOCIALS.tg && (
                            <a
                                className="contactsPage__main_contactsBox_button"
                                href={SOCIALS.tg}
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="Мы в Telegram"
                            >
                                Telegram
                            </a>
                        )} */}
                        {/* <Feedback isText /> */}
                        {/* {SOCIALS.wa && (
                            <a
                                className="contactsPage__main_contactsBox_button"
                                href={SOCIALS.wa}
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="Мы в WhatsApp"
                            >
                                WhatsApp
                            </a>
                        )} */}
                        <div className="contactsPage__main_contactsBox_btnBox">
                            <Feedback />
                            <ActionLinkButton
                                href={SOCIALS.tg}
                                target="_blank"
                                ariaLabel="Мы в Telegram"
                                iconAlt="TG"
                                iconSrc="/icons/mobile/TG.svg"
                                iconSrcDark="/icons/mobile/TG_w.svg"
                            />
                            <ActionLinkButton
                                href={SOCIALS.wa}
                                target="_blank"
                                ariaLabel="Мы в WhatsApp"
                                iconAlt="WA"
                                iconSrc="/icons/mobile/WA.svg"
                                iconSrcDark="/icons/mobile/WA_w.svg"
                            />
                        </div>
                    </div>
                    <div className="contactsPage__main_contactsBox_wrapper">
                        <div className="contactsPage__main_contactsBox_container">
                            <span className="contactsPage__main_contactsBox_container_text">ИНН 5044123930</span>
                            <span className="contactsPage__main_contactsBox_container_text">КПП 504701001</span>
                            <span className="contactsPage__main_contactsBox_container_text">ОГРН 1215000130619</span>
                            <span className="contactsPage__main_contactsBox_container_label">ООО «ИНТРЕЙД»</span>
                        </div>
                    </div>
                    <div className="contactsPage__main_contactsBox_wrapper">
                        <div className="contactsPage__main_contactsBox_container">
                            <a href="tel:+74952806055" className="contactsPage__main_contactsBox_container_value">
                                +7 (495) 280-60-55
                            </a>
                            <span className="contactsPage__main_contactsBox_container_label">Служба поддержки клиентов</span>
                        </div>
                        {/* <div className="contactsPage__main_contactsBox_container">
                            <a href="mailto:info@s-gabai.ru" className="contactsPage__main_contactsBox_container_value">
                                info@s-gabai.ru
                            </a>
                            <span className="contactsPage__main_contactsBox_container_label">По вопросам сотрудничества</span>
                        </div> */}
                        <div className="contactsPage__main_contactsBox_container">
                            <a href="mailto:sales@s-gabai.ru" className="contactsPage__main_contactsBox_container_value">
                                sales@s-gabai.ru
                            </a>
                            <span className="contactsPage__main_contactsBox_container_label">Отдел продаж</span>
                        </div>
                    </div>
                    <div className="contactsPage__main_contactsBox_wrapper">
                        <div className="contactsPage__main_contactsBox_container">
                            <a
                                className="contactsPage__main_contactsBox_container_value"
                                href="https://yandex.ru/maps/-/CHdaa8Ms"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                141580, МО, г. о. Химки, с. Чашниково, <br />
                                ул. Промышленная, стр. 1, корп. 4, оф. 114
                            </a>
                            <span className="contactsPage__main_contactsBox_container_label">Юридический и почтовый адрес</span>
                        </div>
                        <div className="contactsPage__main_contactsBox_container">
                            <span className="contactsPage__main_contactsBox_container_text">Пн–Пт: 10:00–18:00</span>
                            <span className="contactsPage__main_contactsBox_container_label">График работы офиса</span>
                        </div>
                    </div>
                </div>
                <div className="contactsPage__main_map">
                    <MapEmbed />
                </div>
            </main>
            <Footer isMobile={isMobile} />
        </div>
    );
};

export default ContactsPage;
